import React from 'react';
import DatePicker from "react-datepicker2";
import {CDatePickerWrapper, DatePickerIconWrapper} from "./input.styles";

const CustomTimePicker = ({label, id, labelStyle, ...otherProps}) => {
    return (
        <CDatePickerWrapper>
            <label className={`d-block text-end mb-2 ${labelStyle}`} htmlFor={id}>{label}</label>
            <DatePickerIconWrapper>
                <i className='icon-calendar' />
            </DatePickerIconWrapper>
            <DatePicker isGregorian={false} {...otherProps} />
        </CDatePickerWrapper>
    );
};

export default CustomTimePicker;
